import request from '@/utils/request';

function normalizeCartEditPayload(data) {
  if (!data || Object.prototype.toString.call(data) !== '[object Object]') return data;

  const { initialDialogGoldWeigh, ...requestData } = data;
  const hasInitialDialogGoldWeigh =
    initialDialogGoldWeigh !== undefined && initialDialogGoldWeigh !== null && initialDialogGoldWeigh !== '';
  const useCurrentGoldWeigh = hasInitialDialogGoldWeigh && requestData.goldWeigh !== initialDialogGoldWeigh;

  if (useCurrentGoldWeigh) {
    return {
      ...requestData,
      goldWeighSpec: requestData.goldWeigh,
    };
  }

  if (requestData.goldWeighSpec !== undefined && requestData.goldWeighSpec !== null && requestData.goldWeighSpec !== '') {
    return {
      ...requestData,
      goldWeigh: requestData.goldWeighSpec,
    };
  }

  return requestData;
}

//加入post、修改put、删除delete 购物车
export function modifyCartPublic(data, type) {
  return request({
    // baseURL: process.env.VUE_APP_TM_API, //购物车接口单独的端口
    url: '/exhibition/shoppingCart',
    method: type,
    data: type === 'put' ? normalizeCartEditPayload(data) : data,
  });
}
// 获取购物车列表数据
export function cartListData(data) {
  return request({
    // baseURL: process.env.VUE_APP_TM_API, //购物车接口单独的端口
    url: `/exhibition/shoppingCart/list?size=${data.size}&current=${data.current}&styleNumber=${data.styleNumber}&siteId=${data.siteId}&pageType=${data.pageType}&requestFrom=${data.requestFrom}&textureList=${data.textureList}&productCategoryNameList=${data.productCategoryNameList}`,
    method: 'get',
  });
}

// 获取购物车现货列表
export function spotPageList(data) {
  return request({
    // baseURL: process.env.VUE_APP_TM_API, //购物车接口单独的端口
    url: `/exhibition/shoppingCart/getShoppingCartById?cartId=${data.cartId}&current=${data.current}&size=${data.size}`,
    method: 'post',
    data,
  });
}
// 获取购物车素金现货列表
export function spotGoldPageList(data) {
  return request({
    // baseURL: process.env.VUE_APP_TM_API, //购物车接口单独的端口
    url: `/exhibition/shoppingCart/getShoppingCartById?cartId=${data.id}&current=${data.current}&size=${data.size}`,
    method: 'get',
    data,
  });
}
// 获取上次下单信息
export function getOrderInfo() {
  return request({
    // baseURL: process.env.VUE_APP_TM_API, //购物车接口单独的端口
    url: '/exhibition/orderInfo/lastOrder',
    method: 'get',
    params: {},
  });
}
// 删除现货列表
export function deleteSpot(data) {
  return request({
    url: '/exhibition/shoppingCart/deleteShopCartB',
    method: 'PUT',
    data,
  });
}
// 修改购物车定单商品
export function editCart(data) {
  return request({
    url: '/exhibition/shoppingCart/editCart',
    method: 'POST',
    data: normalizeCartEditPayload(data),
  });
}
// 复制购物车定单商品
export function copyCart(data) {
  return request({
    url: '/exhibition/shoppingCart/editCart',
    method: 'POST',
    data,
  });
}
// 下单
export function pushOrder(data) {
  return request({
    // baseURL: process.env.VUE_APP_TM_API, //购物车接口单独的端口
    url: '/exhibition/orderInfo',
    method: 'POST',
    data,
  });
}
// 获取购物车失效商品列表数据
export function getLoseEffectivenessList(data) {
  return request({
    // baseURL: process.env.VUE_APP_TM_API, //购物车接口单独的端口
    url: `/exhibition/shoppingCart/invalid-list?size=${data.size}&current=${data.current}&styleNumber=${data.styleNumber}`,
    method: 'get',
  });
}
// 获取网点列表
export const getNetworkList = (data) => {
  return request({
    url: '/admin/organization/network',
    method: 'get',
    params: data,
  });
};

// 获取金料网点列表
export const getGoldMaterialNetworkList = (data) => {
  return request({
    url: '/eos/materialDeliveryDetails/getOrgList',
    method: 'get',
    params: data,
  });
};

// 获取购物车材质列表
export const getDistinctTextures = (data) => {
  return request({
    url: `/exhibition/shoppingCart/distinctTextures?siteId=${data}`,
    method: 'get',
    params: data,
  });
};
// 获取购物车品类列表
export const getDistinctCategoryNames = (data) => {
  return request({
    url: `/exhibition/shoppingCart/distinctCategoryNames?siteId=${data}`,
    method: 'get',
    params: data,
  });
};
